var _style, _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoles = function SvgRoles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "roles_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".roles_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roles_svg__New_Symbol_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "roles_svg__New_Symbol_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5h10c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1h-10c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1M11.5 18.5h12M17.5 18.5V20M18.4 12.5q.6 0 .9.6l.7 1.4h-5l.7-1.4c.2-.3.5-.6.9-.6z",
    className: "roles_svg__st0"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4,
    r: 3.5,
    className: "roles_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 12.5C9.4 9.9 6.6 8.4 4 9.2 1.9 9.9.5 11.8.5 14v3.5H3l.5 6h4l.5-6h1",
    className: "roles_svg__st0"
  })));
};
export default SvgRoles;